import { Directive } from '@angular/core';

@Directive({
  selector: '[snPlayerFooter]',
  host: {
    class: 'sn-player__footer',
  },
})
export class SnPlayerFooterDirective {
  constructor() {}
}
